import React, { useState } from 'react'
import styled from 'styled-components'
import Button from '../SubComponents/Button'

const Section = styled.div`
width: 100vw;
min-height: 100vh;
background-color: burlywood;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
`

const Title = styled.h1``

const InputSection = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;

input{
	width: 15rem;
	height: 1.5rem;
	border-radius: 10px;
}
`

const Login = () => {
	const [name, setName] = useState('Garvit')
	const [room, setRoom] = useState('Math')

	async function verifyLogin(e) {
		e.preventDefault()

		const response = await fetch(`http://127.0.0.1:5000/api/login?username=${name}&room=${room}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: {}
		})

		const json = await response.json()

		if (json.success) {
			alert('success')

		}
		else {
			alert(json.data)
		}
		
	}

	return (
		<Section>
			<Title>
			<h1 className="h2 mb-3 font-weight-normal">StudUp</h1><br/><br/>
			</Title>
			<form onSubmit={verifyLogin}>
				<InputSection>
				<input type="text" className="nameInput" placeholder="Username" value={name} onChange={(e) => setName(e.target.value)}   required autoFocus/><br/>
				<input type="text" className="roomInput" placeholder="Room" value={room} onChange={(e) => setRoom(e.target.value)} required/><br/>
				</InputSection>
				<Button type="submit" text="Join Room" />
			</form>
		</Section>
	)
}

export default Login